"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mustache_1 = __importDefault(require("mustache"));
/**
 * Simple filtering with dropdown
 *
 * Virtual select drops data-attributes so config-data-property needs to be defined in parent el. Like
 *
 * select name is the field that is used to filter items, which have this in the property (array)
 *
 * <div data-config="filterConfig">
 *  <select class="js-filter" name="filterField">
 *   <option value="">All</option>
 *  ...
 *  </select>
 *
 * <div id="results-container">
 * ...
 * </div>
 * </div>
 *
 * <script>
 * var filterConfig = <%+ JSON.stringify({
 *     items: items,
 *     template: itemTemplate,
 *     resultsEl: 'results-container'
 *  }) %>;
 * </script>
 *
 */
const jsFilter = {
    el: {
        select: null,
        resultsEl: null,
    },
    items: [],
    filteredItems: [],
    filterField: false,
    selected: "",
    itemTemplate: "",
    /**
     * Initialises the functionality.
     * Attaches event handlers to toggle elements
     */
    init(el) {
        console.log("jsFilter init");
        const configName = el.closest("[data-config]")?.dataset.config;
        const config = window[configName];
        this.el = {
            select: el,
            resultsEl: document.getElementById(config.resultsEl),
        };
        this.itemTemplate = config.template;
        this.items = config.items || [];
        this.filterField = el.name;
        if (!this.filterField || !this.items.length) {
            console.log("jsFilter, no filterField or items found");
            return;
        }
        this.addEventListeners(el);
    },
    renderResults() {
        const resultsEl = this.el.resultsEl;
        if (resultsEl) {
            let resultsHtml = "";
            this.filteredItems.forEach((item) => {
                resultsHtml = resultsHtml + mustache_1.default.render(this.itemTemplate, item);
            });
            resultsEl.innerHTML = resultsHtml;
        }
    },
    addEventListeners(el) {
        const select = el;
        const self = this;
        select.addEventListener("change", function () {
            if (this.value.length) {
                self.selected = this.value;
            }
            else {
                self.selected = "";
            }
            self.filterResults();
        });
    },
    filterResults() {
        if (this.selected) {
            this.filteredItems = this.items.filter((item) => item[this.filterField]?.includes(this.selected));
        }
        else {
            this.filteredItems = this.items;
        }
        this.renderResults();
    },
};
exports.default = jsFilter;
